import React from "react";
import { useNavigate } from "react-router-dom";

export const Section_1 = () => {
    const navigate = useNavigate()
    return(
        <>
        <section className="mainSection_1">

            <div className="imgBox">
                <div className="text-box">
                    <p className="text-01">FINEVU DASH CAM GX1600</p>
                    <p className="text-02">STUNNING 4K + QHD RESOLUTION</p>
                    <p><a href="/products/43?product=FineVu-GX1600">LEARN MORE</a></p>
                </div>
                <img className="pc" src="/assets/images/GX1600_PC_1080_1920.jpg" alt="mainBG"/>
                <img className="mo" src="/assets/images/GX1600_M_1080_1920.jpg" alt="mainBG"/>
            </div>

        </section>
        </>
    )
}
